class ScrollableContent {
  containerEl: HTMLElement;
  viewportEl: HTMLElement;
  trackEl: HTMLElement;
  trackThumbEl: HTMLElement;
  itemElArray: HTMLElement[];
  arrowElArray: HTMLElement[];
  maxIndex: number;
  index = 0;

  constructor(element: HTMLElement) {
    this.containerEl = element;
    this.viewportEl = this.containerEl.querySelector(
      ".scrollable-content__viewport"
    ) as HTMLElement;
    this.trackEl = this.containerEl.querySelector(
      ".scrollable-content__track"
    ) as HTMLElement;
    this.trackThumbEl = this.containerEl.querySelector(
      ".scrollable-content__track__thumb"
    ) as HTMLElement;
    this.itemElArray = [].slice.call(
      this.containerEl.querySelectorAll(".scrollable-content__item")
    ) as HTMLElement[];
    this.arrowElArray = [].slice.call(
      this.containerEl.querySelectorAll(".scrollable-content__controls button")
    ) as HTMLElement[];

    this.resize();

    window.addEventListener("resize", this.resize.bind(this));

    for (const arrowEl of this.arrowElArray) {
      arrowEl.addEventListener("click", (e: MouseEvent) => {
        const target = e.currentTarget as HTMLElement;
        this.moveHandler(parseInt(target.dataset.increment));
      });
    }
  }

  resize() {
    const mainContainer = document.querySelector(
      ".scroll-snap-container"
    ) as HTMLElement;
    const bounds = this.viewportEl.getBoundingClientRect();
    const isMobile = document.body.clientWidth <= 980;

    if (this.containerEl.dataset.maxIndex && !isMobile) {
      this.maxIndex = parseInt(this.containerEl.dataset.maxIndex);
    } else {
      this.maxIndex = this.itemElArray.length - 1;
    }

    this.viewportEl.style.width =
      bounds.width + (mainContainer.clientWidth - bounds.right) + "px";
    this.trackThumbEl.style.width =
      this.trackEl.offsetWidth / (this.maxIndex + 1) + "px";

    if (isMobile) {
      this.viewportEl.style.width = "100%";
    }

    // Reset to first slide if current index exceeds maxIndex after resize
    if (this.index > this.maxIndex) {
      this.index = this.maxIndex;
    }

    // Recalculate position for current index with new layout
    this.moveHandler(0);
  }

  moveHandler(increment: number) {
    this.index += increment;

    if (this.index <= 0) this.index = 0;
    if (this.index > this.maxIndex) this.index = this.maxIndex;

    const isMobile = document.body.clientWidth <= 980;

    for (const item of this.itemElArray) {
      if (isMobile) {
        // On mobile, items are 100% width with 2rem gap
        // Movement = index * (100% + 2rem)
        const containerWidth = this.viewportEl.parentElement?.offsetWidth || 0;
        const remSize = parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );
        const gapInRem = 2; // 2rem gap from CSS
        const moveDistanceInPx =
          this.index * (containerWidth + gapInRem * remSize);
        item.style.translate = -moveDistanceInPx / remSize + "rem";
      } else {
        // Desktop/tablet calculation with gap compensation
        item.style.translate =
          (this.index * item.offsetWidth * -1) / 16 - 2 * this.index + "rem";
      }
    }

    this.trackThumbEl.style.translate = this.index * 100 + "%";

    this.containerEl.dataset.index = this.index.toString();
    this.containerEl.dataset.max = (this.index === this.maxIndex).toString();
  }
}

const scrollableContent = () => {
  const scrollableContentElArray = document.querySelectorAll(
    ".scrollable-content"
  );
  const instanceArray = [];

  scrollableContentElArray.forEach((containerEl) => {
    instanceArray.push(new ScrollableContent(containerEl as HTMLElement));
  });
};

export default scrollableContent;
